/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionActionAutopilot_payload = {
    readonly externalEventId: string | null;
    readonly calendarId: string | null;
    readonly hasRoom: boolean | null;
    readonly " $refType": "SuggestionActionAutopilot_payload";
};
export type SuggestionActionAutopilot_payload$data = SuggestionActionAutopilot_payload;
export type SuggestionActionAutopilot_payload$key = {
    readonly " $data"?: SuggestionActionAutopilot_payload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionAutopilot_payload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionActionAutopilot_payload",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalEventId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calendarId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasRoom",
            "storageKey": null
        }
    ],
    "type": "SuggestionActionAutopilotPayload",
    "abstractKey": null
} as any;
(node as any).hash = 'cc446cfacb41986e1255b8dbe490e643';
export default node;
